module.exports = __webpack_public_path__ + "img/logo-MeetingHubwSlogan2020.1f036889.png";